module.exports = __webpack_public_path__ + "media/images/coach-connect-mark-zwart-ec5cf1840fe4a7d7ffd641b1c1bd81f6.svg";